<main>

  <div id="homepageSliders" class="carousel slide" data-ride="carousel" data-interval="3000">
    <ol class="carousel-indicators">
      <li
        *ngFor="let image of homepageSliders; let i = index"
        [attr.data-target]="'#homepageSliders'"
        [attr.data-slide-to]="i"
        [class.active]="i === 0"
    > </li>
    </ol>
    <div class="carousel-inner">
      <div class="carousel-item" *ngFor="let image of homepageSliders; let i = index" [class.active]="i === 0">
        <img class="d-block w-100" [src]="baseApiUrl + '/' + image.file_url" [alt]="image.file_name">
      </div>  
    </div>
    <a class="carousel-control-prev" href="#homepageSliders" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#homepageSliders" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>

  <div class="key-figures">
    <div class="section-content">
      <h4>{{ 'home.Key Figures' | translate }}: {{ keyFigure?.monthName }} {{ keyFigure?.year }}</h4>
      <div class="row no-gutters">
        <div class="col-lg-2 col-md-2 col-sm-2 col-4 mb-3">
          <img [src]="baseApiUrl + '/uploads/images/key_figures/total_assets_icon.png'" alt="" loading="lazy">
          <h3>{{ keyFigure?.total_assets }}M+</h3>
          <h6>Total Assets</h6>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-4 mb-3">
          <img [src]="baseApiUrl + '/uploads/images/key_figures/active_clients_icon.png'" loading="lazy">
          <h3>{{ keyFigure?.active_clients | number }}</h3>
          <h6>Active Clients</h6>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-4 mb-3">
          <img [src]="baseApiUrl + '/uploads/images/key_figures/total_portfolio_icon.png'" loading="lazy">
          <h3>{{ keyFigure?.total_portfolio }}M+</h3>
          <h6>Total Portfolio</h6>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-4 mb-3">
          <img [src]="baseApiUrl + '/uploads/images/key_figures/number_of_offices_icon.png'" loading="lazy">
          <h3>{{ keyFigure?.number_of_offices }}</h3>
          <h6>Number of Offices</h6>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-4 mb-3">
          <img [src]="baseApiUrl + '/uploads/images/key_figures/city_provinces_icon.png'" loading="lazy">
          <h3>{{ keyFigure?.city_provinces }}</h3>
          <h6>City/Provinces</h6>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-4 mb-3">
          <img [src]="baseApiUrl + '/uploads/images/key_figures/districts_icon.png'" loading="lazy">
          <h3>{{ keyFigure?.districts }}</h3>
          <h6>Districts</h6>
        </div>
      </div>
    </div>
  </div>

  <div class="ceo-message">
    <div class="section-content">
      <h4 style="text-transform: uppercase;">{{ "home.CEO's Message" | translate }}</h4>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-12">
          <img [src]="baseApiUrl + '/uploads/images/ceo_message/ceo_picture_1.jpeg'" alt="" loading="lazy">
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-12" *ngIf="isEnglish()">
          <h6 style="font-weight: bold;">{{ ceoMessageEn.title }}</h6>
          <p>{{ ceoMessageEn.text_1 }}</p>
          <!-- <p>{{ ceoMessageEn.text_2 }}</p> -->
          <a class="btn btn-primary" href="/ceo-message" >{{ 'home.Read More' | translate }}</a>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8 col-12" *ngIf="isKhmer()">
          <h6 style="font-weight: bold;">{{ ceoMessageKh.title }}</h6>
          <p>{{ ceoMessageKh.text_1 }}</p>
          <a class="btn btn-primary" href="/ceo-message" >{{ 'home.Read More' | translate }}</a>
        </div>
      </div>
    </div>
  </div>


  <div class="latest-news">
    <div class="section-content">
      <h4 style="text-transform: uppercase;">{{ 'home.Latest News' | translate }}</h4>
      <section>
          <div class="row">
              <div class="col-12">
                  <div id="carouselExampleIndicators2" class="carousel slide" data-ride="carousel">
                      <div class="carousel-inner">
                        <ng-container *ngFor="let chunk of posts | slicePosts:3; let i = index">
                          <div class="carousel-item" [class.active]="i === 0">
                            <div class="row">
                              <div class="col-md-4 mb-3" *ngFor="let post of chunk">
                                <div class="card">
                                  <a [routerLink]="'/all-posts/detail/' + post.id">
                                    <img
                                      width="300"
                                      height="300"
                                      class="img-fluid"
                                      [src]="baseApiUrl + '/' + post.image"
                                      alt="Post image"
                                      loading="lazy"
                                    />
                                    <div class="card-body">
                                      <h4 class="card-title"></h4>
                                      <h6 *ngIf="isEnglish()" class="card-text">{{ post.title }}</h6>
                                      <h6 *ngIf="isKhmer()" class="card-text">{{ post.title_kh }}</h6>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>

                  </div>
              </div>
              <div class="col-6">
                
              </div>
              <div class="col-6 text-right">
                <a class="btn btn-primary mb-3 mr-1" href="#carouselExampleIndicators2" role="button" data-slide="prev">
                    <img [src]="baseApiUrl + '/uploads/images/icons/left_arrow.png'" alt="" style="width: auto; height: 15px;" loading="lazy">
                </a>
                <a class="btn btn-primary mb-3 " href="#carouselExampleIndicators2" role="button" data-slide="next">
                    <img [src]="baseApiUrl + '/uploads/images/icons/right_arrow.png'" alt="" style="width: auto; height: 15px;" loading="lazy">
                </a>
              </div>
          </div>
      </section>
    </div>
  </div>

  <div class="mobile-download">
    <a href="/download-app"><img [src]="baseApiUrl + '/uploads/images/mobile_download/mobile_download_1.jpg'" loading="lazy"></a>
  </div>

  <div class="overview">
    <div class="section-content">
      <h4>{{ 'home.Overview' | translate }}</h4>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-12">
          <h5>{{ 'home.Our Network' | translate }}</h5>
          <img [src]="baseApiUrl + '/uploads/images/overview/overview_1.jpg'" alt="" loading="lazy">
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-12">
          <h5>{{ 'home.Core Value' | translate }}</h5>
          <img [src]="baseApiUrl + '/uploads/images/overview/overview_2.jpg'" alt="" loading="lazy">
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-12">
          <h5>{{ 'home.Customer Service' | translate }}</h5>
          <img [src]="baseApiUrl + '/uploads/images/overview/overview_3.jpg'" alt="" loading="lazy">
        </div>
      </div>
    </div>
  </div>

</main>